/** Savings model: what could be saved per subscription, honoring usage marks. */

import type { Subscription } from '../lib/types';
import type { UsageStore } from './usage';

/** Potential monthly savings for one subscription. */
export function savingsFor(sub: Subscription, usage: UsageStore): number {
  if (sub.status !== 'active') return 0;
  const mark = usage.get(sub.key);
  if (mark === 'never' || mark === 'rarely') return sub.monthlyCost;
  return sub.flags.reduce((a, f) => a + f.savings, 0);
}

export function savingsReason(sub: Subscription, usage: UsageStore): string | null {
  const mark = usage.get(sub.key);
  if (mark === 'never') return 'You marked this as never used — cancel it.';
  if (mark === 'rarely') return 'You marked this as rarely used — consider cancelling or pausing.';
  const hike = sub.flags.find((f) => f.type === 'price-hike');
  return hike ? hike.detail : null;
}

export function totalSavings(subs: Subscription[], usage: UsageStore): number {
  return subs.reduce((a, s) => a + savingsFor(s, usage), 0);
}
